import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { X, Loader2 } from 'lucide-react';
import { toast } from 'react-toastify';
import { changeBillingPlan } from '../../redux/features/authSlice';

const PLANS = [
  { id: 2, name: 'Starter', eur: 19 },
  { id: 3, name: 'Standard', eur: 39 },
  { id: 4, name: 'Business', eur: 79 },
  { id: 5, name: 'Premium', eur: 149 },
];

const ChangePlanModal = ({ open, onClose, currentPackageId }) => {
  const dispatch = useDispatch();
  const [pending, setPending] = useState(null);

  if (!open) return null;

  const handleSelect = async (pkgId) => {
    if (pkgId === currentPackageId) {
      toast.info('To je već vaš trenutni plan.');
      return;
    }
    setPending(pkgId);
    try {
      await dispatch(changeBillingPlan(pkgId)).unwrap();
      toast.success('Plan je ažuriran.');
      onClose();
    } catch (err) {
      const msg =
        typeof err === 'string'
          ? err
          : typeof err?.payload === 'string'
            ? err.payload
            : err?.message || err?.error || 'Greška pri promeni plana.';
      toast.error(msg);
    } finally {
      setPending(null);
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60" role="dialog" aria-modal="true">
      <div className="bg-gray-800 border border-gray-600 rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-700">
          <h2 className="text-lg font-semibold text-white">Promena plana</h2>
          <button
            type="button"
            onClick={onClose}
            className="p-1 rounded-lg text-gray-400 hover:text-white hover:bg-gray-700"
            aria-label="Zatvori"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="px-5 pt-3 text-sm text-gray-400">
          Cena se u tekućem mesecu deli brojem dana u mesecu; svaka promena plana važi od trenutka izbora (po kalendarskim danima).
        </p>
        <ul className="p-5 space-y-2">
          {PLANS.map((p) => {
            const isCurrent = p.id === currentPackageId;
            const loading = pending === p.id;
            return (
              <li key={p.id}>
                <button
                  type="button"
                  disabled={!!pending}
                  onClick={() => handleSelect(p.id)}
                  className={`w-full flex items-center justify-between rounded-lg px-4 py-3 text-left transition-colors ${
                    isCurrent
                      ? 'bg-emerald-900/40 border border-emerald-600 text-emerald-100'
                      : 'bg-gray-700/80 border border-gray-600 text-white hover:bg-gray-700'
                  }`}
                >
                  <span className="font-medium">
                    {p.name}
                    {isCurrent && <span className="ml-2 text-xs opacity-80">(trenutno)</span>}
                  </span>
                  <span className="text-sm text-gray-300">
                    {loading ? <Loader2 className="w-4 h-4 animate-spin inline" /> : `${p.eur} € / mes.`}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ChangePlanModal;
